import React, { useEffect } from 'react';
import { CircleMarker, MapContainer, TileLayer, Tooltip, useMap } from 'react-leaflet';
import { naira } from '../../utils/format';
import type { Listing } from '../../types/housing';
interface ListingMapProps {
  listings: Listing[];
  campus: {
    lat: number;
    lng: number;
    name: string;
  };
  activeId: string | null;
  onSelect: (id: string) => void;
}
function FocusOnActive({
  listings,
  activeId
}: {
  listings: Listing[];
  activeId: string | null;
}) {
  const map = useMap();
  useEffect(() => {
    const active = listings.find(listing => listing.id === activeId);
    if (active) {
      map.panTo([active.lat, active.lng], {
        animate: true,
        duration: 0.25
      });
    }
  }, [activeId, listings, map]);
  return null;
}
export function ListingMap({
  listings,
  campus,
  activeId,
  onSelect
}: ListingMapProps) {
  return <MapContainer center={[campus.lat, campus.lng]} zoom={13} scrollWheelZoom={false} className="h-full w-full" attributionControl={false} data-id="element-1966" data-mp="ddr96wmtdwzb">
      <TileLayer url="https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png" data-id="element-1967" data-mp="kbtyobva2hiw" />
      <FocusOnActive listings={listings} activeId={activeId} data-id="element-1968" data-mp="p9lw1leoyvuh" />

      <CircleMarker center={[campus.lat, campus.lng]} radius={9} pathOptions={{
      color: '#0f172a',
      weight: 2,
      fillColor: '#0f172a',
      fillOpacity: 0.85
    }} data-id="element-1969" data-mp="p7rcaaf5p9rz">
        <Tooltip direction="top" offset={[0, -8]} data-id="element-1970" data-mp="y3qo285kadbl">
          {campus.name}
        </Tooltip>
      </CircleMarker>

      {listings.map(listing => {
      const active = listing.id === activeId;
      return <CircleMarker key={listing.id} center={[listing.lat, listing.lng]} radius={active ? 11 : 7} pathOptions={{
        color: '#ffffff',
        weight: 2,
        fillColor: active ? '#0f766e' : '#5b6a7d',
        fillOpacity: 1
      }} eventHandlers={{
        click: () => onSelect(listing.id)
      }} data-id="element-1971" data-mp="182g5jztjpvrb">
            <Tooltip direction="top" offset={[0, -8]} data-id="element-1972" data-mp="py6b2uhxlivs">
              <span className="text-[12px] font-semibold" data-id="element-1973" data-mp="pyzcrh219i72">{listing.name}</span>
              <br data-id="element-1974" data-mp="kzwce9x0005f" />
              <span className="text-[12px]" data-id="element-1975" data-mp="l0eh7uxq7moy">
                {naira(listing.rentPerYear)} · {listing.minutesToCampus} min
              </span>
            </Tooltip>
          </CircleMarker>;
    })}
    </MapContainer>;
}